import React from 'react';

const About = ({ aboutSection = [], styles = {} }) => {
  return (
    <section className="index-about" id="about-us">
      <picture>
        <source media="(min-width: 769px)" srcSet={aboutSection.aboutCloudBg} type="image/webp" />
        <source media="(max-width: 768px)" srcSet="data:image/gif;base64,01" type="image/gif" />
        <img
          className="index-about-bg lazyloaded"
          data-src={aboutSection.aboutCloudBg}
          alt={aboutSection.altCloudBg}
          src={aboutSection.aboutCloudBg}
          loading="lazy"
        />
      </picture>
      <div className="index-about-inner container-block">
        <div className="index-about-content">
          <h2 className="index-about-heading index-heading-blue index-heading-blue-atp">
            About Us
          </h2>
          <div className="index-about-text" children={aboutSection.aboutT}/>
          <a className="index-about-link"
             href={aboutSection.readMore.link} children={aboutSection.readMore.btn}/>
        </div>
        <div className="index-about-imgs">
          <figure className="index-about-img-small-figure">
            <picture>
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.aboutImgs.imgSmallWebP}
                type="image/webp"
              />
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.aboutImgs.imgSmallPng}
                type="image/png"
              />
              <source
                media="(max-width: 960px)"
                srcSet="data:image/gif;base64,01"
                type="image/gif"
              />
              <img
                data-src={aboutSection.aboutImgs.dataSrc}
                className="index-about-img-small lazyloaded"
                alt={aboutSection.aboutImgs.title}
                title={aboutSection.aboutImgs.title}
                src={aboutSection.aboutImgs.dataSrc}
                loading="lazy"
              />
            </picture>
          </figure>
          <figure className="index-about-img-big-figure">
            <picture>
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.imgBigFigure.imgBigWebp}
                type="image/webp"
              />
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.imgBigFigure.imgBigPng}
                type="image/png"
              />
              <source
                media="(max-width: 960px)"
                srcSet="data:image/gif;base64,01"
                type="image/gif"
              />
              <img
                data-src={aboutSection.imgBigFigure.dataSrc}
                className="index-about-img-big lazyloaded"
                alt={aboutSection.imgBigFigure.imgBigTitle}
                title={aboutSection.imgBigFigure.imgBigTitle}
                src={aboutSection.imgBigFigure.dataSrc}
                loading="lazy"
              />
            </picture>
          </figure>
          <figure className={`index-airplane-top-left-figure ${styles.aboutTopLeft}`}>
            <picture>
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.airplaneTopLeft.imgPlanWebp}
                type="image/webp"
              />
              <source
                media="(min-width: 961px)"
                srcSet={aboutSection.airplaneTopLeft.imgPlanPng}
                type="image/png"
              />
              <source
                media="(max-width: 960px)"
                srcSet="data:image/gif;base64,01"
                type="image/gif"
              />
              <img
                data-src={aboutSection.airplaneTopLeft.dataSrc}
                className="index-airplane-top-left lazyloaded"
                alt={aboutSection.airplaneTopLeft.titleTopLeft}
                title={aboutSection.airplaneTopLeft.titleTopLeft}
                src={aboutSection.airplaneTopLeft.dataSrc}
                loading="lazy"
              />
            </picture>
            <svg
              width={aboutSection.svgSprite.width}
              height={aboutSection.svgSprite.height}
              className="svg-sprite doted-curve-svg"
            >
              <use href={aboutSection.svgSprite.link}/>
            </svg>
          </figure>
          <figure className={`index-airplane-top-right-figure ${styles.aboutTopRight}`}>
            <picture>
              <source
                media="(min-width: 1261px)"
                srcSet={aboutSection.airplaneTopRight.imgPlanWebp}
                type="image/webp"
              />
              <source
                media="(min-width: 1261px)"
                srcSet={aboutSection.airplaneTopRight.imgPlanPng}
                type="image/png"
              />
              <source
                media="(max-width: 1260px)"
                srcSet="data:image/gif;base64,01"
                type="image/gif"
              />
              <img
                data-src={aboutSection.airplaneTopRight.dataSrc}
                className="index-airplane-top-right lazyloaded"
                alt={aboutSection.airplaneTopRight.titleTopRight}
                title={aboutSection.airplaneTopRight.titleTopRight}
                src={aboutSection.airplaneTopRight.dataSrc}
                loading="lazy"
                height="80"
                width="229"
              />
            </picture>
            <svg
              width={aboutSection.svgSprite.width}
              height={aboutSection.svgSprite.height}
              className={`svg-sprite doted-curve-svg ${styles.topRightShape}`}
            >
              <use href={aboutSection.svgSprite.link}/>
            </svg>
          </figure>
          <figure className={`index-airplane-bottom-left-figure ${styles.aboutBottomLeft}`}>
            <picture>
              <source
                media="(min-width: 1261px)"
                srcSet={aboutSection.airplaneBottomLeft.imgPlanWebp}
                type="image/webp"
              />
              <source
                media="(min-width: 1261px)"
                srcSet={aboutSection.airplaneBottomLeft.imgPlanPng}
                type="image/png"
              />
              <source
                media="(max-width: 1260px)"
                srcSet="data:image/gif;base64,01"
                type="image/gif"
              />
              <img
                data-src={aboutSection.airplaneBottomLeft.dataSrc}
                className="index-airplane-bottom-left lazyloaded"
                alt={aboutSection.airplaneBottomLeft.titleBottomLeft}
                title={aboutSection.airplaneBottomLeft.titleBottomLeft}
                src={aboutSection.airplaneBottomLeft.dataSrc}
                loading="lazy"
              />
            </picture>
            <svg
              width={aboutSection.svgSprite.width}
              height={aboutSection.svgSprite.height}
              className="svg-sprite doted-curve-svg"
            >
              <use href={aboutSection.svgSprite.link}/>
            </svg>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default About;
